import React from 'react'
import PropTypes from 'prop-types'

import CustomPropTypes from '../../customPropTypes'

import Head from './Head'

const Page = (props) => (
  <div className={props.className}>
    <Head {...props.meta} script={props.script} />
    {props.children}
  </div>
)

Page.propTypes = {
  children: CustomPropTypes.children,
  className: PropTypes.string,
  meta: PropTypes.shape({
    description: PropTypes.string.isRequired,
    image: PropTypes.shape({}).isRequired,
    og: PropTypes.shape({}).isRequired,
    title: PropTypes.string.isRequired,
    twitter: PropTypes.shape({}).isRequired,
    nonIndexable: PropTypes.bool,
  }).isRequired,
  script: PropTypes.shape({}),
}

export default Page
